export const ANY = 'ANY' as const;
export const MORNING = 'MORNING' as const;
export const NOON = 'NOON' as const;
export const AFTERNOON = 'AFTERNOON' as const;
